import React, { useEffect } from "react";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import bytesToDisplayHelper from "../../../../utils/bytesToDisplayHelper.js";
import config from "config";
import parse from "html-react-parser";
import { useModal } from "contexts/modalContext/modalContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Button from "components/Elements/Button/Button.js";

const arrowImage = `${config.api.resource}/assets/icons/arrow-back.svg`;

const EmbedErrorsModal = ({ typeError, embedDetails }) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { closeModal } = useModal();
  useEffect(() => {
    const nextButton = document.querySelector(".uppy-StatusBar-actionBtn");
    if (nextButton) {
      nextButton.innerHTML = getTextByKey("upload-send");
      //icont in button
      const img = document.createElement("IMG");
      img.src = arrowImage;
      img.className = "jm-icon white-icon no-js-search";
      //append icon to button and button to ui
      nextButton.appendChild(img);
    }
  }, []);

  const renderText = () => {
    switch (typeError.exitCode) {
      case "masxstorageviolation":
        return getHtmlByKey("text-masxstorageviolation");
      case "maxsizeviolation":
        return getHtmlByKey("text-maxsizeviolation");
      case "formatserror":
        return "";
      case "maxfileserror":
        return getHtmlByKey("text-maxfileserror");
      case "maxdeliveriespermonth":
        return getHtmlByKey("text-max-deliveries-per-month");
      case "error":
        return returnErrorConst(999);
      default:
        return returnErrorConst(999);
    }
  };
  const renderLimit = () => {
    let str = "";
    if (typeError.limit) {
      switch (typeError.exitCode) {
        case "masxstorageviolation":
          str += "";
          break;
        case "maxsizeviolation":
          str +=
            bytesToDisplayHelper(typeError.limit).size +
            bytesToDisplayHelper(typeError.limit).type;
          break;
        case "formatserror":
          str += "";
          break;
        case "maxfileserror":
          str += typeError.limit;
          break;
        case "error":
          str += "";
          break;
        default:
          str += "";
          break;
      }
    }
    return str;
  };

  const returnErrorConst = (num) => {
    let errText = getTextByKey("api-error");
    errText = errText.replace("#ERRORNUM#", num);
    errText = errText.replace("#SYSMAIL#", "contact-us");
    errText = errText.replace("#SYSMAIL#", config.supportmail);
    errText = errText.replace("#SYSMAIL#", "contact-us");
    return parse(errText);
  };

  const getEmbedFormatMessage = () => {
    let str1 = "";
    let str2 = "";
    if (embedDetails.Embed_Dynamic_Formats_Action) {
      if (embedDetails.Embed_Dynamic_Formats_Action.toLowerCase() === "only") {
        str1 += getHtmlByKey("upload-formats-not-allowed-only");
      } else if (
        embedDetails.Embed_Dynamic_Formats_Action.toLowerCase() === "exclude"
      ) {
        str1 += getHtmlByKey("upload-formats-not-allowed-exclude");
      }
    }

    if (embedDetails.Embed_Dynamic_Formats) {
      let formatlist = embedDetails.Embed_Dynamic_Formats;
      if (embedDetails.Embed_Dynamic_Formats.includes(",")) {
        formatlist = embedDetails.Embed_Dynamic_Formats.replaceAll(",", ", ");
      }
      str2 += " ";
      str2 += formatlist;
    }
    return (
      <div>
        {str1}
        <span className="formats">{str2}</span>
      </div>
    );
  };

  const returnDirection = () => {
    if (
      embedDetails.Embed_Dynamic_Culture === "he-IL" ||
      embedDetails.Embed_Dynamic_Culture === "ar-SA"
    ) {
      return "rtl";
    } else {
      return "ltr";
    }
  };

  const replaceFilesLimitText = (text) => {
    const filesLimit = typeError.limit;
    return text.replace("#countFiles#", filesLimit);
  };

  const replaceSizeLimitText = (text) => {
    const sizeLimit = bytesToDisplayHelper(typeError.limit);
    return text.replace("#sizeLimit#", sizeLimit.size + sizeLimit.type);
  };

  const replaceFormatsText = (text) => {
    let formatlist = "";
    if (embedDetails.Embed_Dynamic_Formats) {
      formatlist = embedDetails.Embed_Dynamic_Formats;
      if (embedDetails.Embed_Dynamic_Formats.includes(",")) {
        formatlist = embedDetails.Embed_Dynamic_Formats.replaceAll(",", ", ");
      }
    }

    return text.replace("#formatsList#", formatlist);
  };

  const renderFormatMessage = () => {
    let text = "";
    if (embedDetails.Embed_Dynamic_Formats_Action) {
      if (embedDetails.Embed_Dynamic_Formats_Action.toLowerCase() === "only") {
        text = getTextByKey("upload-jumboform-error-only-formats");
      } else {
        text = getTextByKey("upload-jumboform-error-not-allowed-formats");
      }
    }

    return replaceFormatsText(text);
  };

  const renderErrorText = () => {
    switch (typeError.exitCode) {
      case "masxstorageviolation":
        return getHtmlByKey("text-masxstorageviolation");
      case "maxsizeviolation":
        return parse(
          replaceSizeLimitText(getTextByKey("upload-jumboform-error-max-size"))
        );
      case "formatserror":
        return parse(renderFormatMessage());
      case "maxfileserror":
        return parse(
          replaceFilesLimitText(
            getTextByKey("upload-jumboform-error-max-files")
          )
        );
      case "maxdeliveriespermonth":
        return getHtmlByKey("text-max-deliveries-per-month");
      case "error":
        return returnErrorConst(999);
      default:
        return returnErrorConst(999);
    }
  };

  return (
    <div
      className={`embed-form-error-modal embed-form-error-modal-${returnDirection()}`}
      style={{ direction: returnDirection() }}
    >
      <div className="exit" onClick={() => closeModal()}>
        <Icon name="x" />
      </div>
      <div className="content-error-form">
        <div className="error-image">
          <Icon name="cloud-embed-error" ext="svg" />
        </div>
        <div className="error-title">
          {getTextByKey("upload-jumboform-error-title")}
        </div>
        <div className="error-text">{renderErrorText()}</div>
        <div className="error-ok-button">
          <Button className="new-button" onClick={() => closeModal()}>
            {getTextByKey("error-jumboform-ok-button")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmbedErrorsModal;
